export type AccountMenuItem = 'info' | 'config' | 'access-log' | 'logout';

/** 역할마다 보이는 항목(admin: 4개, member: 2개) */
export const ACCOUNT_MENU_ITEMS: Record<'admin' | 'member', readonly AccountMenuItem[]> = {
  admin: ['info', 'config', 'access-log', 'logout'],
  member: ['info', 'logout'],
};
